import { generateClient, get, post } from "aws-amplify/api";
import { getVoucherCategory } from "../../Utils/VoucherUtils";
import { getAnalyticsIds } from "../../firebase";

const client = generateClient();

export async function pay(dispatch, payload) {
  try {
    dispatch({ type: "PAY" });

    const { products, paymentMethod, voucher, phone, usePoint = 0 } = payload;

    const params = {
      products,
      paymentMethod,
    };

    if (voucher) {
      params.voucher = voucher;
    }

    if (phone) {
      params.phone = phone;
    }

    if (usePoint > 0) {
      params.usePoint = usePoint;
    }

    const analyticsIds = await getAnalyticsIds();
    if (analyticsIds) {
      params.analytics = analyticsIds;
    }

    const request = post({
      apiName: "checkout",
      path: "/pay",
      options: {
        body: params,
      },
    });

    const { body } = await request.response;

    const result = await body.json();

    dispatch({
      type: "PAY_SUCCESS",
      payload: { payment: result },
    });
  } catch (error) {
    dispatch({ type: "PAY_ERROR", error });
  }
}

export async function verifyVoucher(dispatch, payload) {
  try {
    dispatch({ type: "VERIFY_VOUCHER" });

    const { code, productType } = payload;

    const params = {
      code,
      productType,
    };

    const request = post({
      apiName: "checkout",
      path: "/verify/voucher",
      options: {
        body: params,
      },
    });

    const { body } = await request.response;
    const res = await body.json();
    const { voucher } = res.data;

    dispatch({
      type: "VERIFY_VOUCHER_SUCCESS",
      payload: { voucher },
    });
  } catch (error) {
    dispatch({ type: "VERIFY_VOUCHER_ERROR", error });
  }
}

export function clearVoucher(dispatch) {
  dispatch({ type: "CLEAR_VOUCHER" });
}

export async function requestListVoucher(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_VOUCHERS" });

    const { userID } = payload;

    const productType = getVoucherCategory(payload?.productType);

    // Fetch public voucher

    let vouchers = [];
    let voucherNextToken = "start";
    let voucherParams = {};

    if (productType) {
      voucherParams = { filter: { category: { eq: productType } } };
    }

    while (voucherNextToken) {
      if (voucherNextToken && voucherNextToken !== "start") {
        voucherParams.nextToken = voucherNextToken;
      }
      const res = await client.graphql({
        query: listVouchers,
        variables: voucherParams,
      });
      vouchers = [...vouchers, ...res.data.listVouchers.items];
      voucherNextToken = res.data.listVouchers.nextToken;
    }

    // Fetch subscription voucher

    let subscriptionItems = [];
    let subscriptionNextToken = "start";
    let subscriptionParams = {
      userID,
      limit: 20,
      sortDirection: "DESC",
      expiredAt: { gt: new Date().toISOString() },
    };

    while (subscriptionNextToken) {
      if (subscriptionNextToken && subscriptionNextToken !== "start") {
        subscriptionParams.nextToken = subscriptionNextToken;
      }
      const res = await client.graphql({
        query: subscriptionsByUserExpiredAt,
        variables: subscriptionParams,
      });
      subscriptionItems = [
        ...subscriptionItems,
        ...res.data.subscriptionsByUserExpiredAt.items,
      ];
      subscriptionNextToken = res.data.subscriptionsByUserExpiredAt.nextToken;
    }

    const subscriptionVouchers = subscriptionItems
      .filter((item) => {
        if (item.totalAvailable) {
          return (
            item.totalAvailable > 0 && item.voucher?.category === productType
          );
        }
        return item.voucher?.category === productType;
      })
      .map((item) => {
        return item.voucher;
      });

    // Fetch claimed voucher

    let claimedItems = [];
    let claimedVoucherNextToken = "start";
    const claimedVoucherParams = {
      userID,
    };

    while (claimedVoucherNextToken) {
      if (claimedVoucherNextToken && claimedVoucherNextToken !== "start") {
        claimedVoucherParams.nextToken = claimedVoucherNextToken;
      }

      const res = await client.graphql({
        query: claimedVouchersByUser,
        variables: claimedVoucherParams,
      });

      claimedItems = [...claimedItems, ...res.data.claimedVouchersByUser.items];
      claimedVoucherNextToken = res.data.claimedVouchersByUser.nextToken;
    }

    const claimedVouchers = claimedItems.map((item) => {
      return item.voucher;
    });

    let allVouchers = [
      ...vouchers,
      ...subscriptionVouchers,
      ...claimedVouchers,
    ];

    if (payload.subtotal) {
      allVouchers = allVouchers.sort((a, b) => {
        let aTotal = a.total;
        if (a.type === "PERCENTAGE") {
          aTotal = (a.total / 100) * payload.subtotal;
        }

        let bTotal = b.total;
        if (b.type === "PERCENTAGE") {
          bTotal = (b.total / 100) * payload.subtotal;
        }

        return bTotal - aTotal;
      });
    }

    dispatch({
      type: "LIST_VOUCHERS_SUCCESS",
      payload: {
        vouchers: allVouchers,
        subscriptionVouchers,
      },
    });
  } catch (error) {
    dispatch({ type: "LIST_VOUCHERS_ERROR", error });
  }
}

export async function requestGetVoucher(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_GET_VOUCHER" });

    const { user, id } = payload;

    if (user.referralID && id === user.referralID) {
      throw new Error("The voucher code is invalid. Please try again.");
    }

    // Verifikasi kode selalu butuh kategori; tanpa tipe produk, `general`.
    const productType = getVoucherCategory(payload?.productType) || "general";

    const params = { code: id, productType };

    let verifiedVoucher = {};
    let subscriptionVoucher = {};

    try {
      const request = post({
        apiName: "checkout",
        path: "/verify/voucher",
        options: {
          body: params,
        },
      });

      const { body } = await request.response;
      const res = await body.json();
      verifiedVoucher = res.data.voucher;
    } catch (error) {
      // If verification fails, proceed to fetch from subscriptions
    }

    if (!verifiedVoucher.id) {
      let subscriptionItems = [];
      let subscriptionNextToken = "start";
      let subscriptionParams = {
        userID: user.id,
        limit: 20,
        sortDirection: "DESC",
        expiredAt: { gt: new Date().toISOString() },
      };

      while (subscriptionNextToken) {
        if (subscriptionNextToken && subscriptionNextToken !== "start") {
          subscriptionParams.nextToken = subscriptionNextToken;
        }
        const res = await client.graphql({
          query: subscriptionsByUserExpiredAt,
          variables: subscriptionParams,
        });
        subscriptionItems = [
          ...subscriptionItems,
          ...res.data.subscriptionsByUserExpiredAt.items,
        ];
        subscriptionNextToken = res.data.subscriptionsByUserExpiredAt.nextToken;
      }

      const subscriptionVouchers = subscriptionItems
        .filter((item) => {
          if (item.totalAvailable) {
            return (
              item.totalAvailable > 0 && item.voucher?.category === productType
            );
          }
          return item.voucher?.category === productType;
        })
        .map((item) => {
          return item.voucher;
        });

      subscriptionVoucher = subscriptionVouchers.find(
        (voucher) => voucher.id === id
      );
    }

    let selectedVoucher = verifiedVoucher.id
      ? verifiedVoucher
      : subscriptionVoucher;

    if (!selectedVoucher?.id) {
      throw new Error("Voucher not found.");
    }

    if (
      selectedVoucher.category !== productType &&
      selectedVoucher.category !== "general"
    ) {
      throw new Error(
        `Voucher only valid for ${selectedVoucher.category} product. Please try again.`
      );
    }

    dispatch({
      type: "GET_VOUCHER_SUCCESS",
      payload: {
        voucher: selectedVoucher,
      },
    });
  } catch (error) {
    dispatch({ type: "GET_VOUCHER_ERROR", error });
  }
}

export async function requestPaymentMethods(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_PAYMENT_METHODS" });

    let path = "/status";
    if (payload?.productType) {
      path = `/status?productType=${payload.productType}`;
    }

    const request = get({
      apiName: "checkout",
      path: path,
    });

    const response = await request.response;
    const result = await response.body.json();

    result.methods = result.methods.filter((method) => {
      return method.id !== "voucher";
    });

    dispatch({
      type: "LIST_PAYMENT_METHODS_SUCCESS",
      payload: { paymentStatus: result },
    });
  } catch (error) {
    dispatch({ type: "LIST_PAYMENT_METHODS_ERROR", error });
  }
}

// The cart holds consultation phone numbers and free-form tax descriptions, so
// it must not sit in localStorage indefinitely on a shared device. Entries are
// stamped on write and discarded once stale.
export const CART_STORAGE_KEY = "products";
const CART_TTL_MS = 24 * 60 * 60 * 1000;
const CART_SAVED_AT_KEY = "productsSavedAt";

export const clearStoredCart = () => {
  localStorage.removeItem(CART_STORAGE_KEY);
  localStorage.removeItem(CART_SAVED_AT_KEY);
};

const writeStoredCart = (products) => {
  localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(products));
  localStorage.setItem(CART_SAVED_AT_KEY, String(Date.now()));
};

export const readStoredCart = () => {
  const savedAt = parseInt(localStorage.getItem(CART_SAVED_AT_KEY), 10);

  // An unstamped cart predates this change; treat it as expired rather than
  // trusting it for an unknown length of time.
  if (!savedAt || Date.now() - savedAt > CART_TTL_MS) {
    clearStoredCart();
    return [];
  }

  try {
    const parsed = JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    clearStoredCart();
    return [];
  }
};

export async function getCartProducts(dispatch) {
  try {
    dispatch({ type: "LIST_CART_PRODUCTS" });

    const allProducts = readStoredCart();

    dispatch({ type: "LIST_CART_PRODUCTS_SUCCESS", payload: { allProducts } });
  } catch (error) {
    dispatch({ type: "LIST_CART_PRODUCTS_ERROR", payload: { error } });
  }
}

export async function addToCart(dispatch, payload) {
  try {
    const { products } = payload;

    dispatch({ type: "ADD_TO_CART" });

    writeStoredCart(products);

    dispatch({
      type: "ADD_TO_CART_SUCCESS",
      payload: { allProducts: products },
    });
  } catch (error) {
    dispatch({ type: "ADD_TO_CART_ERROR", error });
  }
}

export async function removeFromCart(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REMOVE_FROM_CART" });

    let allProducts = readStoredCart();

    allProducts = allProducts.filter((product) => {
      if (
        payload?.type === "consultation" ||
        payload?.type === "consultation-extend"
      ) {
        if (
          product.id?.startsWith("video-") ||
          product.id?.startsWith("zoom-")
        ) {
          return false;
        }
      }

      if (payload?.type === "business-service") {
        if (product.type === "business-service-addon") {
          return false;
        }
      }
      return product.id !== id;
    });

    writeStoredCart(allProducts);

    dispatch({ type: "REMOVE_FROM_CART_SUCCESS", payload: { allProducts } });
  } catch (error) {
    dispatch({ type: "REMOVE_FROM_CART_ERROR", error });
  }
}

export async function clearCart(dispatch, payload) {
  try {
    dispatch({ type: "CLEAR_CART" });
    clearStoredCart();
    dispatch({ type: "CLEAR_CART_SUCCESS" });
  } catch (error) {
    dispatch({ type: "CLEAR_CART_ERROR", error });
  }
}

export async function requestListRedeemedVoucher(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_REDEEMED_VOUCHER" });
    const { userID } = payload;

    let redeemedVouchers = [];
    let redeemedVoucherNextToken = "start";
    let redeemedVoucherParams = {
      userID,
    };

    while (redeemedVoucherNextToken) {
      if (redeemedVoucherNextToken && redeemedVoucherNextToken !== "start") {
        redeemedVoucherParams.nextToken = redeemedVoucherNextToken;
      }
      const res = await client.graphql({
        query: redeemedVouchersByUserVoucher,
        variables: redeemedVoucherParams,
      });
      redeemedVouchers = [
        ...redeemedVouchers,
        ...res.data.redeemedVouchersByUserVoucher.items,
      ];
      redeemedVoucherNextToken =
        res.data.redeemedVouchersByUserVoucher.nextToken;
    }

    dispatch({
      type: "LIST_REDEEMED_VOUCHER_SUCCESS",
      payload: { redeemedVouchers },
    });
  } catch (error) {
    dispatch({ type: "LIST_REDEEMED_VOUCHER_ERROR", error });
  }
}

export async function clearPayError(dispatch) {
  dispatch({ type: "CLEAR_PAY_ERROR" });
}

// eslint-disable-next-line no-unused-vars
const getVoucher = /* GraphQL */ `
  query GetVoucher($id: ID!) {
    getVoucher(id: $id) {
      id
      title
      description
      category
      type
      total
      maxDiscount
      limit
      expiredAt
      createdAt
      updatedAt
    }
  }
`;

const listVouchers = /* GraphQL */ `
  query ListVouchers(
    $filter: ModelVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVouchers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        category
        type
        total
        maxDiscount
        limit
        expiredAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const subscriptionsByUserExpiredAt = /* GraphQL */ `
  query SubscriptionsByUserExpiredAt(
    $userID: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPackageSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionsByUserExpiredAt(
      userID: $userID
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        packageID
        userID
        voucher {
          id
          title
          description
          category
          type
          total
          maxDiscount
          limit
          expiredAt
          createdAt
          updatedAt
        }
        totalAvailable
        expiredAt
        createdAt
        updatedAt
        user {
          id
          identityId
          name
          email
          phone
          callBalance
          membership
          createdAt
          updatedAt
        }
        package {
          id
          title
          description
          icon
          features
          type
          membershipType
          period
          periodType
          price
          callBalance
          voucherType
          limit
          total
          available
          offeredInIAP
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

const redeemedVouchersByUserVoucher = /* GraphQL */ `
  query RedeemedVouchersByUserVoucher(
    $userID: ID
    $voucherID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redeemedVouchersByUserVoucher(
      userID: $userID
      voucherID: $voucherID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const claimedVouchersByUser = /* GraphQL */ `
  query ClaimedVouchersByUser(
    $userID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserClaimedVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    claimedVouchersByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucher {
          id
          title
          description
          category
          type
          total
          maxDiscount
          limit
          expiredAt
        }
        userID
        claimedAt
        createdAt
      }
      nextToken
    }
  }
`;
